import { TIMEZONE_GMT } from '@mews-commander/constants';
import { GeneralEnterprise, GeneralPricingMode } from '@mews-commander/data-access';
import { CustomLink } from '@mews-commander/types';

interface MewsEnterpriseParams {
    customLinks: Array<CustomLink>;
    editableHistoryIntervalMilliseconds?: undefined;
    mewsId: string;
    name: string;
    isOnboardingFinished: boolean;
    shortName: null;
}

export const mewsEnterprise: GeneralEnterprise & MewsEnterpriseParams = {
    name: 'Mews',
    shortName: null,
    customLinks: [],
    id: null as unknown as string,
    mewsId: 'mews',
    address: {
        line1: null,
        line2: null,
        city: null,
        postalCode: null,
        subdivisionCode: null,
        countryCode: '',
    },
    timeZoneIdentifier: TIMEZONE_GMT,

    // These fields are not used in the context of mewsEnterprise, they are here just for compatibility with GeneralEnterprise
    chainId: '',
    subscriptionId: '',
    cityId: '',
    addressId: '',
    uniqueName: '',
    email: '',
    telephone: '',
    websiteUrl: '',
    defaultLanguageCode: '',
    defaultCurrencyCode: '',
    defaultCultureName: '',
    legalEnvironmentCode: '',
    accountingEnvironmentCode: '',
    accommodationEnvironmentCode: '',
    taxEnvironmentCode: '',
    operationalEditableHistoryWindow: '',
    accountingEditableHistoryWindow: '',
    createdUtc: '',
    pricing: GeneralPricingMode.Gross,
    isOnboardingFinished: true,
};
